import * as React from 'react';
import { Link } from 'react-router-dom';

import { Button } from '@/components/ui/button';

interface QuickLinkButtonProps {
  icon: React.ComponentType<{ className?: string }>;
  label: string;
  to: string;
  badge?: string | number;
}

export function QuickLinkButton({
  icon: Icon,
  label,
  to,
  badge,
}: QuickLinkButtonProps) {
  return (
    <Link to={to}>
      <Button
        variant="ghost"
        className="w-full justify-start gap-3 px-4 py-3 h-auto bg-slate-50 hover:bg-slate-100 border border-slate-200 text-slate-700 font-medium"
      >
        <Icon className="h-4 w-4 text-slate-500" />
        <span className="flex-1 text-left">{label}</span>
        {badge !== undefined && (
          <span className="bg-blue-100 text-blue-700 text-xs font-semibold px-2 py-0.5 rounded-full">
            {badge}
          </span>
        )}
      </Button>
    </Link>
  );
}
